export default __webpack_public_path__ + "static/media/tat_img4.35190bec.webp";